import React from 'react';
import TourProvider from './TourProvider';

const GlobalTourProvider = ({ children }) => {
  return (
    <TourProvider>
      {children}
    </TourProvider>
  );
};

export default GlobalTourProvider;
